import Request from '@/plugins/request';

export function getSaleDailyStats(params) {
  return Request.get('sale-daily-stats', { params })
}

export function createSaleDailyStat() {
  return Request.get(`sale-daily-stats/create`)
}

export function storeSaleDailyStat(data) {
  return Request.post('sale-daily-stats', data)
}

export function updateSaleDailyStat(id, data) {
  return Request.put(`sale-daily-stats/${id}`, data)
}

export function editSaleDailyStat(id) {
  return Request.get(`sale-daily-stats/${id}/edit`)
}

export function destroySaleDailyStat(id) {
  return Request.delete(`sale-daily-stats/${id}`)
}
